import { z } from "zod";

/**
 * Phase 32 REQ-COMP-001 GDPR erasure response schema.
 *
 * Backend response z `POST /api/admin/users/{userId}/erase` — viz
 * `backend/api/src/main/kotlin/cz/axigon/api/admin/GdprErasureRoute.kt`.
 */

export const gdprErasureResponseSchema = z.object({
  target_user_id: z.string().uuid(),
  audit_log_entry_id: z.string().uuid(),
  duration_ms: z.number().int().nonnegative(),
  completed_at: z.string(),
  rows_redacted_by_entity: z.record(z.string(), z.number().int().nonnegative()),
});

export type GdprErasureResponse = z.infer<typeof gdprErasureResponseSchema>;

/**
 * 6 entit, které cascade redact musí pokrýt. Frontend renderuje tabulku
 * v completion modálu na základě tohoto pořadí.
 */
export const GDPR_CASCADE_ENTITIES = [
  "users",
  "audit_log",
  "fio_transaction",
  "email_log",
  "consent",
  "push_assist_delivery",
] as const;
